/**
 * Global exports for Highcharts theme utilities.
 *
 * Exposes theme functions to window.SAMChartTheme for use in inline
 * template scripts that can't import TypeScript modules directly.
 */

import type { HighchartsStatic } from "./chartTheme";
import {
  DARK_THEME_OPTIONS,
  initializeHighchartsTheme,
  isDarkMode,
  LIGHT_THEME_OPTIONS,
  setupThemeObserver,
} from "./chartTheme";

/**
 * Global SAMChartTheme interface for window augmentation.
 */
export interface SAMChartThemeGlobal {
  isDarkMode: typeof isDarkMode;
  initializeTheme: (Highcharts: HighchartsStatic) => void;
  setupObserver: typeof setupThemeObserver;
  DARK_THEME_OPTIONS: typeof DARK_THEME_OPTIONS;
  LIGHT_THEME_OPTIONS: typeof LIGHT_THEME_OPTIONS;
}

// Augment window with SAMChartTheme
declare global {
  interface Window {
    SAMChartTheme: SAMChartThemeGlobal;
  }
}

// Expose to window for inline template scripts
window.SAMChartTheme = {
  isDarkMode,
  initializeTheme: initializeHighchartsTheme,
  setupObserver: setupThemeObserver,
  DARK_THEME_OPTIONS,
  LIGHT_THEME_OPTIONS,
};
